import PropTypes from 'prop-types';
import React from 'react';

import Float, { FloatProps } from '../ui/Float';
import useSystemSettings from '../hooks/useSystemSettings';
import { SystemSettings } from '../ifmsTypes';
import _ from 'lodash';

function getDecimal(systemSettings:SystemSettings|null, currency:string|null) {
  if (!currency || !systemSettings) {
    return 4;
  }

  if (!!systemSettings.currencies && systemSettings.currencies.length > 0) {
    const c = systemSettings.currencies.find(x => x.currency === currency);
    return !!c ? c.decimal : 0;
  }

  return 0;
}

export interface CurrencyProps extends FloatProps {
  currency: string,
};

function Currency(props: CurrencyProps) {
  const systemSettings = useSystemSettings();

  
  const {currency, ...other} = props;
  const decimal = _.isEmpty(currency) ? 0 : getDecimal(systemSettings, currency);

  return <Float decimals={decimal} {...other} />

};

Currency.defaultProps = {
  onChange: () => {},
  disabled: false,
  dark: false,
  error: false,
};

Currency.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  dark: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  floatId: PropTypes.string,
  error: PropTypes.bool.isRequired,
  currency: PropTypes.string,
  onTabNext: PropTypes.func,
  onTabPrevious: PropTypes.func,
  onEnter: PropTypes.func,
  onDoubleClick : PropTypes.func,
};


export default React.memo(Currency);
